<template>
  <v-divider></v-divider>
  <v-card-text class="py-0 px-4">
    <v-tabs color="primary" density="compact" slider-color="blue-darken-3">
      <v-tab v-for="tab in tabs" :key="tab.label" :to="tab.to" replace>
        <span class="mr-2">{{ tab.label }}</span>
        <v-chip
          v-if="'count' in tab"
          :color="tab.count ? 'yellow-darken-4' : 'grey-darken-2'"
          density="compact"
          rounded="lg"
          size="small">
          <span class="font-weight-bold">{{ tab.count }}</span>
        </v-chip>
      </v-tab>
    </v-tabs>
  </v-card-text>
  <v-divider></v-divider>
</template>

<script lang="ts" setup>
import { useIncident } from '../Incident'

defineOptions({
  name: 'IncidentTabs',
})

const { tabs } = useIncident()
</script>
